module.exports = __webpack_public_path__ + "media/SuiteApp/assets/svg/img/mesuite_logo-afbf9b59f450b58738db3d4cfe2edcf4.svg";